import React, { CSSProperties, useEffect } from 'react';
import { Row, FormInstance } from 'antd';
import clsx from 'clsx';
import InputCode from './Input';
import { numberOTP } from '../../../../contstant';

import styles from './index.module.scss';

interface InputCodeWrapperProps {
  className?: string;
  style?: CSSProperties;
  form: FormInstance;
}

function InputCodeWrapper({ className, form, style }: InputCodeWrapperProps) {
  useEffect(() => {
    const handlePaste = (event: ClipboardEvent) => {
      event.preventDefault();
      const clipboardText = event?.clipboardData?.getData('text/plain');

      clipboardText?.split('').forEach((number, i) => {
        form.setFieldValue(`number-${i + 1}`, number);
      });
    };

    window.addEventListener('paste', handlePaste);

    return () => {
      window.removeEventListener('paste', handlePaste);
    };
  }, [form]);

  return (
    <Row gutter={24} className={clsx(styles.wrapper, className)} style={style}>
      {Array.from({ length: numberOTP }, (_, i) => i + 1).map((id) => (
        <InputCode key={id} id={id} form={form} />
      ))}
    </Row>
  );
}

InputCodeWrapper.defaultProps = {
  style: undefined,
  className: undefined,
};

export default InputCodeWrapper;
